/**
 * Wraps an Iterable of values and/or promises in an AsyncIterable that yields each resolved value, in order.
 * Each value is only pulled from `values` and awaited once the consumer asks for it, the same as
 * `for await` over a plain (sync) Iterable, so callers can iterate serially with `for await`.
 */
export async function* toAsyncIterable<R>(values: Iterable<R | PromiseLike<R>>): AsyncGenerator<R> {
  for (const value of values) {
    yield value;
  }
}
